<template>
  <div class="content">
      <Header></Header>
		<div class="mission">
        <div class="luckyDraw-list">
          <div class="prize-t app-en">
            {{$t('luckyTips1')}}
          </div>
          <div class="prize-c">
            <div class="prize-one">
              <div class="img">
                <img style="height:260px;" :src="list[0].image" />
              </div>
              <div class="prize-name app-en">
                <strong class="">{{list[0].name}}</strong>
              </div>
            </div>
            <div class="prize-one prize-two">
              <div class="">
                <div class="flex flex-center" style="align-items: end;">
                  <div>
                    <div class="img">
                      <img style="margin-bottom: -20px;width:210px;margin: 0 auto;" :src="list[1].image" />
                    </div>
                    <div class="prize-name app-en">
                      <strong class="">{{list[1].name}}</strong>
                    </div>
                  </div>
                  <div>
                    <div class="img">
                      <img :src="list[2].image" style="width:140px;margin: 0 auto;" />
                    </div>
                    <div class="prize-name app-en">
                      <strong class="">{{list[2].name}}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="price-c3 mt20 flex flex-center">
              <div class="prize-one prize-three" v-for="(item,index) in list" v-if="index>2">
                <div class="img" v-if="index==3">
                  <img :src="item.image" />
                </div>
                <div class="img" v-if="index!=3">
                  <img  style="width: 160px;" :src="item.image" />
                </div>
                <div class="prize-name app-en">
                  <strong class="">{{item.name}}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
		</div>
   </div>
</template>
<script>
import Header from '../components/header'
export default {
    components:{
		Header
    },
    data() {

    return {
			notFound:true,
			list:[],
      listTip:[],
			page_id:1,
			page_size:10,
			isShow:'All',

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
      back(){
        this.$router.push({path:'/'})
      },
      getHome(){
        let that =this;
        this.$parent.loadModal(true);
        that.$api.get('/api/index/prize',null,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
              that.list = r.data.list
              if(that.list.length>0){
                that.notFound = false
              }else{
                that.notFound = true
              }
              that.listTip = r.data.tip

        });
      })
    },
    getList(item){
      this.isShow = item
    },
		getMore(){
			let that = this;
			if(that.isShow){
				that.page_id++;
				that.getHome();
			}else{
				//that.$utils.alertText(that.$t('noMore'));
			}
		},
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/luckyDraw.vue